import React from 'react';
import { Icon, Row, Col, Button, message, Modal, Radio, Switch, Popover, Checkbox } from 'antd';
import BaseContainer from '../../../containers/base';
import moment from 'moment';
import Event from 'react-eventproxy';
import { AreaManage } from '../../../utils/websocket';
import Common from '../../../components/common';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import API from '../../../utils/api'
import Background_icon from '../../../images/broadcast_icon.png';
import Change_icon from '../../../images/change_icon.png';

// let client = new MqttClient();

/**
 * 产生随机整数，包含下限值，但不包括上限值
 * @param {Number} lower 下限
 * @param {Number} upper 上限
 * @return {Number} 返回在下限到上限之间的一个随机整数
 */
function random(lower, upper) {
    return Math.floor(Math.random() * (upper - lower)) + lower;
}

export default class extends BaseContainer {
    constructor(props) {
        super(props);
        this.state = {
            dataSource: [],
            chioseGameArray: [],
            activeAreaId: 0,
            activeAreaStatus: false, //默认空闲
            activeIndex: 0,
            activeAreaCondition: true,
            activeAreaGames: [],
        }
    }

    componentDidMount() {
        this.getdDtaSource() 
    }

    /**
     * 获取游戏区域
     */
    getdDtaSource = () => {
        const hide = message.loading('请稍后...', 0);
        const self = this;
        const storeId = Common.getStoreInfo().storeId
        this.Api.getStoreAreaGame(storeId).then(dataSource => {
            self.setState({
                dataSource,
            })
            hide()
            this.gamesShowHide();
        }).catch(e => {
            message.error(e || '服务器出现问题');
            hide()
        })
        this.queueEvent();
    }

    /**
     * websocket消息推送
     */
    queueEvent = () => {
        const self = this;
        Event.on(AreaManage, ({ data, option }) => {
            // console.log("区域管理推送", option);
            const { dataSource, activeIndex, activeAreaGames } = self.state;
            if (option == 'areaStatusChange') {   //同步区域开关状态
                let newDataSource = [...dataSource]
                if (data && data.length > 0) {
                    newDataSource.forEach((item, index) => {
                        if (item.areaId == data[0].areaId) {
                            item.areaQueue = data[0].areaQueue
                            item.areaQueueStatus = data[0].areaQueueStatus
                            item.areaStatus = data[0].areaStatus
                        }
                    })
                    self.setState({
                        dataSource: newDataSource,
                    })
                }
            }
            if (option == 'areaGameUpdate') { //区域下配置 显示的游戏
                let newDataSource = [...dataSource]
                newDataSource.forEach((item, index) => {
                    if (item.areaId == data[0].areaId) {
                        for (let i = 0; i < item.areaGames.length; i++) {
                            let itemType = item.areaGames[i]
                            itemType.queueGameOption = false
                            for (let j = 0; j < data[0].areaGames.length; j++) {
                                let index = data[0].areaGames[j]
                                if (itemType.gaId == index.gaId) {
                                    itemType.queueGameOption = true
                                }
                            }
                        }
                    }
                })
                self.setState({
                    dataSource: newDataSource
                })
                this.gamesShowHide();
            }
            if (option == 'areaGameQueueChange') {
                const { activeAreaGames } = self.state
                let newActiveAreaGames = [...activeAreaGames]
                if (data.option == 'start') {//开始游戏结束游戏
                    for (let p = 0; p < data.areaQueueGameList.length; p++) { //胖子给的数据
                        let pItem = data.areaQueueGameList[p]
                        for (let i = 0; i < newActiveAreaGames.length; i++) {//原数据
                            let iItem = newActiveAreaGames[i]
                            if (iItem.gameId == pItem.gameId) {
                                for (let a = 0; a < iItem.queueList.length; a++) {
                                    let aItem = iItem.queueList[a]
                                    if (aItem.queueGameId == pItem.queueGameId) {
                                        aItem.status = pItem.status
                                    }
                                }
                            }
                        }
                    }
                    self.setState({
                        activeAreaGames: newActiveAreaGames
                    })
                }
                if (data.option == 'over') {//结束游戏
                    for (let p = 0; p < data.areaQueueGameList.length; p++) { //胖子给的数据
                        let pItem = data.areaQueueGameList[p]
                        for (let i = 0; i < newActiveAreaGames.length; i++) {//原数据
                            let iItem = newActiveAreaGames[i]
                            if (iItem.gameId == pItem.gameId) {
                                for (let a = 0; a < iItem.queueList.length; a++) {
                                    let aItem = iItem.queueList[a]
                                    if (aItem.queueGameId == pItem.queueGameId) {
                                        iItem.queueList.splice(a, 1)
                                    }
                                }
                            }
                        }
                    }
                    self.setState({
                        activeAreaGames: newActiveAreaGames
                    })
                }
            }
            if (option == 'customerChange') { // 取消排队、更换区域
                const { activeAreaGames } = self.state
                let newActiveAreaGames = [...activeAreaGames]
                if (data.option == 'remove') {
                    for (let p = 0; p < data.areaQueueGameList.length; p++) { //胖子给的数据
                        let pItem = data.areaQueueGameList[p]
                        for (let i = 0; i < newActiveAreaGames.length; i++) {//原数据
                            let iItem = newActiveAreaGames[i]
                            if (iItem.gameId == pItem.gameId) {
                                for (let a = 0; a < iItem.queueList.length; a++) {
                                    let aItem = iItem.queueList[a]
                                    if (aItem.queueGameId == pItem.queueGameId) {
                                        iItem.queueList.splice(a, 1)
                                    }
                                }
                            }
                        }
                    }
                    self.setState({
                        activeAreaGames: newActiveAreaGames
                    })
                }
                if (data.option == 'add') {//更换区域,添加顾客
                    for (let i = 0; i < newActiveAreaGames.length; i++) { //循环数据源
                        let Iitem = newActiveAreaGames[i]
                        for (let t = 0; t < data.areaQueueGameList.length; t++) {//循环胖子的数据
                            let Titem = data.areaQueueGameList[t]
                            if (Iitem.areaId == Titem.areaId) {
                                if (Iitem.gameId == Titem.gameId) {
                                    Iitem.queueList = Iitem.queueList.concat(Titem.queueList)
                                }
                            }

                        }
                    }
                    self.setState({
                        activeAreaGames: newActiveAreaGames
                    })
                }
            }
            if (option == 'PriorityUpdate') {//客户优先级消息同步
                const { activeAreaGames } = self.state
                let newActiveAreaGames = [...activeAreaGames];
                for (let index = 0; index < data.length; index++) {
                    let changeItem = data[index];
                    //胖子给的
                    for (let y = 0; y < newActiveAreaGames.length; y++) {
                        let areaGameItem = newActiveAreaGames[y];
                        if (areaGameItem.gameId == changeItem.gameId) {
                            for (let z = 0; z < areaGameItem.queueList.length; z++) {
                                let queueItem = areaGameItem.queueList[z];
                                if (queueItem.queueGameId == changeItem.queueGameId) {
                                    queueItem.priority = changeItem.priority;
                                }
                            }
                        }

                    }
                }
                self.setState({
                    activeAreaGames: newActiveAreaGames
                })
            }
            if (option == 'CustomerStatusUpdate') {//顾客状态
                const { activeAreaGames } = self.state
                let newActiveAreaGames = [...activeAreaGames];
                for (let index = 0; index < data.length; index++) {
                    let changeItem = data[index];
                    //胖子给的
                    for (let y = 0; y < newActiveAreaGames.length; y++) {
                        let areaGameItem = newActiveAreaGames[y];
                        if (areaGameItem.gameId == changeItem.gameId) {
                            for (let z = 0; z < areaGameItem.queueList.length; z++) {
                                let queueItem = areaGameItem.queueList[z];
                                if (queueItem.queueGameId == changeItem.queueGameId) {
                                    queueItem.customerStatus = changeItem.customerStatus;
                                }
                            }
                        }

                    }
                }
                self.setState({
                    activeAreaGames: newActiveAreaGames
                })
            }
            if (option == 'areaGamePersonNumberUpdate') {//推送已接待、总排队
                const { activeAreaGames } = self.state;
                const newActiveAreaGames = [...activeAreaGames]
                for (let i = 0; i < newActiveAreaGames.length; i++) {
                    let indexItem = newActiveAreaGames[i]
                    for (let s = 0; s < data.length; s++) {
                        let sItem = data[s]
                        if (indexItem.areaId == sItem.areaId) {
                            if(indexItem.gameId ==sItem.gameId ){
                                indexItem.over = sItem.over;
                                indexItem.total = sItem.total
                            }
                        }
                    }
                }
                self.setState({
                    activeAreaGames: newActiveAreaGames
                })
            }

        });
    }

    onGListChangeIndex = (gameId, listed, params) => {
        const self = this;
        let { activeAreaGames } = this.state;
        let data = [...activeAreaGames];
        let changeGameIndex = data.findIndex(item => item.gameId == gameId)
        data[changeGameIndex].queueList = listed;
        API.changeSeat(params).then(res => {
            self.setState({ activeAreaGames: data });
        }).catch(e => {
            message.error(e || '调整顺序失败')
        })
    }

    /**
     * 根据游戏是否选中配置显示游戏列表
     */
    gamesShowHide = () => {
        const { dataSource, activeIndex } = this.state
        let arrGames = []
        dataSource[activeIndex].areaGames.map((item, index) => {
            if (item.queueGameOption) {
                arrGames.push(item.gameId)
            }
        })
        const areaId = dataSource[activeIndex].areaId
        const stringGames = arrGames.toString()
        API.getNewAreaGameList(areaId, stringGames).then((res) => {
            const arrGamesList = []
            res.map((item, index) => {
                arrGamesList.push(item.gaId)
            })
            this.setState({
                activeAreaGames: res,
                chioseGameArray: arrGamesList
            })
        }).catch((e) => {
            message.error(`查询失败:${e}`);
        })
    }

    /**
     * 根据配置的游戏获取游戏数据
     */
    getMangeGames = (choseType, gameInfo) => {
        const { chioseGameArray } = this.state;
        let chioseGameArray_ = [...chioseGameArray]
        const newGaId = gameInfo.gaId;
        if (choseType) {
            chioseGameArray_.push(newGaId)
        } else {
            chioseGameArray_ = chioseGameArray_.filter(item => item != newGaId);
        }
        this.setState({
            chioseGameArray: chioseGameArray_
        }, () => {
            const areaId = gameInfo.areaId;
            const gaIds = chioseGameArray_.toString();
            let params = {
                areaId,
                gaIds
            }
            API.disposeAreaGameList(params).then((res) => {
            }).catch((e) => {
                // 如果该区域当前游戏有排队，则不能取消展示
                chioseGameArray_.push(newGaId)
                this.setState({
                    chioseGameArray: chioseGameArray_
                })
                message.error(e);
            })
        })
    }

    // 序列化游戏数组
    chunk = (arr, size) => {
        let arr2 = [];
        for (let i = 0; i < arr.length; i = i + size) {
            arr2.push(arr.slice(i, i + size));
        }
        return arr2;
    }

    /**
     * 配置该区域下显示的游戏
     */
    gameQueueMange = (areaGames) => {
        if (areaGames && areaGames.length > 0) {
            const serializeArray = this.chunk(areaGames, 2)
            return (
                serializeArray && serializeArray.length > 0 ?
                    <div style={{ backgroundColor: '#1A1736', borderRadius: 8, padding: 10,}} >
                        <div style={{ color: '#6E738E', fontSize: 14, marginBottom: 10 }}>选中的游戏可以进行排队叫号操作</div>
                        {
                            serializeArray.map((item, index) => {
                                return <Row key={`lomni-${index}`}>
                                    {
                                        item.map((it, index) => {
                                            return <Col span={12} key={`hahsbd-${index}`}>
                                                <Checkbox key={it.gaId} checked={it.queueGameOption} onChange={(e) => {
                                                    this.getMangeGames(e.target.checked, it);
                                                }} style={{ fontSize: 14, color: 'white', padding: 3, margin: 2 }}>{it.gameName}
                                                </Checkbox>
                                            </Col>
                                        })
                                    }
                                </Row>
                            })
                        }
                    </div> : null
            )
        }
    }

    render() {
        const self = this;
        const offSW = document.querySelector('body').offsetWidth - 120;
        const offS = document.querySelector('body').clientHeight - 120;
        const { dataSource, activeAreaId, activeIndex, activeAreaStatus, activeAreaCondition, activeAreaGames } = self.state;
        const tabs = dataSource;
        return (
            <div style={{ backgroundColor: '#232041', display: 'flex', flexDirection: 'column', padding: 10, overflowY: 'auto', padding: 20, width: offSW, height: offS, borderRadius: 5 }}>
                <TabList getdDtaSource={this.getdDtaSource} checkJurisdiction={this.checkJurisdiction} data={tabs} onChangeTab={(index) => {
                    const hide = message.loading('请稍后', 0);
                    this.setState({
                        // activeAreaGames: dataSource[index].queueList,
                        activeAreaId: dataSource[index].areaId,
                        activeAreaStatus: dataSource[index].areaStatus,
                        activeIndex: index,
                        activeAreaCondition: dataSource[index].areaCondition ? true : false,
                    }, () => {
                        self.gamesShowHide()
                        hide();
                    })
                }} />
                <SwitchChange gameQueueMange={self.gameQueueMange} dataSource={dataSource} activeIndex={activeIndex} checkJurisdiction={this.checkJurisdiction} />
                <div id='queueBar' style={{ flex: 1, display: 'flex', flexDirection: 'row', overflowX: 'auto', marginTop: 20, }}>
                    {
                        activeAreaGames && activeAreaGames.length > 0 ? (activeAreaGames.map(item => {
                            return <GameList areaStatus={activeAreaStatus} index={activeIndex} {...item} key={`gl_${activeAreaId}-${item.gameId}`} onChangeIndex={this.onGListChangeIndex} getdDtaSource={this.gamesShowHide} checkJurisdiction={this.checkJurisdiction} />;
                        })) : self.emptyPage()
                    }
                </div>
            </div>

        );
    }

    /**
     * 空页面
     */
    emptyPage = () => {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1, flexDirection: 'column' }}>
                <img src={require('../../../images/none_icon.png')} style={{ width: 120, height: 95 }} />
                <div style={{ fontSize: 20, color: '#fff', marginTop: 30 }}>该区域内暂无游戏队列…</div>
            </div>
        )
    }

    // getTabs() {
    //     const { dataSource } = this.state;
    //     console.log(dataSource)
    //     let tabs = [];
    //     dataSource.map(item => {
    //         const { areaId, areaName, areaStatus } = item;
    //         tabs.push({
    //             areaId, areaName, areaStatus
    //         });
    //     })
    //     return tabs;
    // }

    /**
     * 查看当前区域是否有操作权限
     */
    checkJurisdiction = () => {
        const { dataSource, activeIndex, } = this.state
        if (dataSource.length > 0) {
            const countterArea = dataSource[activeIndex].areaName
            const JurisdictionArrayArea = Common.getUserArea()
            const myMangeArea = JurisdictionArrayArea.findIndex((value) => { return value.areaName == countterArea })
            return myMangeArea
        }
    }

}

/**
 * 配置游戏是否展示
 */
class SwitchChange extends React.Component {
    static defaultProps = {
        item: null
    }

    render() {
        const { dataSource, activeIndex, gameQueueMange } = this.props
        const areaGames = dataSource[activeIndex] && dataSource[activeIndex].areaGames;
        const areaName = dataSource[activeIndex] && dataSource[activeIndex].areaName;
        const JurisdictionType = this.props.checkJurisdiction(); //检测是否有操作权限
        return (
            <div style={{ marginTop: 20, alignItems: 'center', display: 'flex', flexDirection: 'row' }}>
                <img src={require('../../../images/queueManage.png')} style={{ width: 28, height: 28 }} />
                <div style={{ fontSize: 16, color: 'white', marginLeft: 8, width: 180, }}>{`${areaName} 队列管理`}</div>
                {
                    JurisdictionType < 0 ? <div onClick={() => { message.warning('对不起，您没有该区操作权限') }} style={{ fontSize: 14, color: 'white', padding: '5px 15px', backgroundColor: '#1A1736', borderRadius: 15, cursor: 'pointer', marginLeft: 40 }}>游戏队列管理<Icon type="caret-down" style={{ marginLeft: 8 }} /></div> : <Popover content={gameQueueMange(areaGames)} trigger="click" placement="bottomLeft" >
                        <div style={{ padding: '5px 15px', backgroundColor: '#1A1736', borderRadius: 15, display: 'flex', justifyContent: 'center', alignItems: 'center', marginLeft: 40, cursor: 'pointer' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                <div style={{ fontSize: 14, color: 'white', }}>游戏队列管理</div>
                                <Icon type="caret-down" style={{ marginLeft: 8 }} />
                            </div>
                        </div>
                    </Popover>
                }
            </div>
        );
    }

}

/**
 * Tab 区域导航组件
 */
class TabList extends React.Component {
    static defaultProps = {
        data: []
    }
    constructor(props) {
        super(props);
        this.state = {
            activeIndex: 0
        }
    }

    render() {
        const self = this;
        const { data, getdDtaSource, checkJurisdiction } = this.props;
        return (
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ padding: '10px 20px', backgroundColor: '#1A1736', borderRadius: 25, display: 'flex', flexDirection: 'row', maxWidth: 1200, flexWrap: 'wrap' }}>
                    {
                        data.map((item, index) => {
                            return <TabItem key={`tItem_${item.areaId}`} isSelected={index == self.state.activeIndex} index={index} data={item} onChangeTab={(index) => {
                                const { activeIndex } = self.state;
                                if (activeIndex != index) {
                                    self.setState({
                                        activeIndex: index
                                    }, () => {
                                        self.props.onChangeTab && self.props.onChangeTab(index)
                                    })
                                }
                            }} />
                        })
                    }
                </div>
                <AreaButton activeIndex={self.state.activeIndex} storeAreaGameInfo={data} getdDtaSource={getdDtaSource} checkJurisdiction={checkJurisdiction} />
            </div>
        );
    }

}

/**
 * 区域 叫号、排队 开关
 */
class AreaButton extends React.Component {

    render() {
        const RightBtnStyle = { width: 88, height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 25, fontSize: 14, color: 'white', border: 'none' };
        const { storeAreaGameInfo, activeIndex } = this.props
        const arrayCallType = storeAreaGameInfo[activeIndex] && storeAreaGameInfo[activeIndex].areaStatus;
        const arrayType = storeAreaGameInfo[activeIndex] && storeAreaGameInfo[activeIndex].areaQueueStatus;
        return (
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <Button style={{ ...RightBtnStyle, marginRight: 20, backgroundColor: arrayCallType ? '#22E6A3' : '#1A1736', }} onClick={() => { this.showOrHideMaintain() }}>{arrayCallType ? '叫号开启' : '区域维护'}</Button>
                <Maintain ref={o => this.OpenMaintainModal = o} storeAreaGameInfo={storeAreaGameInfo} activeIndex={activeIndex} />
                <Button style={{ ...RightBtnStyle, backgroundColor: arrayType ? '#22E6A3' : '#1A1736', }} onClick={() => { this.showOrHideQueue() }}>{arrayType ? '开启排队' : '停止排队'}</Button>
                <Queueup ref={o => this.OpenQueueupModal = o} storeAreaGameInfo={storeAreaGameInfo} activeIndex={activeIndex} />
            </div>
        )
    }

    showOrHideMaintain = () => {
        const JurisdictionType = this.props.checkJurisdiction(); //检测是否有操作权限
        if (JurisdictionType < 0) {
            message.warning('对不起，您没有该区操作权限')
            return false;
        }
        this.OpenMaintainModal.showModal();
    }

    showOrHideQueue = () => {
        const JurisdictionType = this.props.checkJurisdiction(); //检测是否有操作权限
        if (JurisdictionType < 0) {
            message.warning('对不起，您没有该区操作权限')
            return false;
        }
        this.OpenQueueupModal.showModal();
    }

}

/**
 * 区域Tab按钮
 */
class TabItem extends React.Component {
    static defaultProps = {
        data: [],
        index: 0,
        isSelected: false
    }
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onChangeTab = this.onChangeTab.bind(this);
    }

    render() {
        const { data, isSelected } = this.props;
        const { areaStatus } = data;
        return (
            <div onClick={this.onChangeTab} key={data.areaId} style={{ padding: '0 10px', margin: '0 5px', display: 'flex', flexDirection: 'row', alignItems: 'center', backgroundColor: isSelected ? "#322F52" : "", borderRadius: 15, cursor: 'pointer', }}>
                <div onClick={this.onChange} style={{ width: 14, height: 14, display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: !areaStatus ? '#82FF60' : '#E25050', borderRadius: 7 }}></div>
                <div style={{ height: 30, display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                    <span style={{ color: 'white', fontSize: 10, marginLeft: 10 }}>{data.areaName}</span>
                </div>
            </div>
        );
    }

    onChangeTab() {
        this.props.onChangeTab && this.props.onChangeTab(this.props.index);
    }

    onChange() {
        return;
        let { areaStatus } = this.state;
        this.setState({ areaStatus: !areaStatus });
        //** 发送socket通知
    }

}

const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};

class GameList extends BaseContainer {
    static defaultProps = {
        "gameAreas": [],
        "over": 0,
        "total": 0,
        "gameName": "",
        "queues": [],
        "gameAreasSize": 1
    }
    constructor(props) {
        super(props);
        this.onDragEnd = this.onDragEnd.bind(this);
        let data = this.createPlayingData();
        this.state = {
            data,
            gameStatus: false,
        }
    }

    onDragEnd(result) {
        const JurisdictionType = this.props.checkJurisdiction(); //检测是否有操作权限
        if (JurisdictionType < 0) {
            message.warning('对不起，您没有该区操作权限')
            return false;
        }
        const { areaId, gameId } = this.props;
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        if (this.props.queueList[result.source.index].status > 0) {
            return;
        } else {
            const items = reorder(
                [...this.props.queueList],
                result.source.index, //拖动的
                result.destination.index //交换的
            );
            const type = result.source.index - result.destination.index < 0 ? 1 : 2;
            let params = {
                // areaId,
                // gameId,
                // type,
                startTarget: type == 1 ? this.props.queueList[result.source.index].queueGameId : this.props.queueList[result.destination.index].queueGameId,
                endTarget: type == 1 ? this.props.queueList[result.destination.index].queueGameId : this.props.queueList[result.source.index].queueGameId,

            }
            this.props.onChangeIndex && this.props.onChangeIndex(gameId, items, params);
        }
    }

    getSelectQueues = () => {
        const { areaId, gameId, } = this.props;
        const dKey = `${areaId}-${gameId}`;
        let selectQueueGameIds = [];
        let selectOrderTicketItemId = [];
        let queues = this.state.data[dKey];
        if (queues && Object.keys(queues).length > 0) {
            let qKeys = Object.keys(queues);
            qKeys.forEach(key => {
                if (queues[key].selected) {
                    selectQueueGameIds.push(queues[key].queueGameId);
                    selectOrderTicketItemId.push(queues[key].orderTicketItemId)
                }
            });
        }
        let selectQueues = selectQueueGameIds.toString();
        let selectOrderTicketItemIds = selectOrderTicketItemId.toString();
        let selectQueue = { selectQueues, selectOrderTicketItemIds }
        return selectQueue;
    }

    onBeginPress = () => {
        //开始游戏  
        const JurisdictionType = this.props.checkJurisdiction(); //检测是否有操作权限
        if (JurisdictionType < 0) {
            message.warning('对不起，您没有该区操作权限')
            return false;
        }
        const self = this;
        let queues = self.getSelectQueues();
        const params = {
            queueGameIds: queues.selectQueues,
            orderTicketItemIds: queues.selectOrderTicketItemIds,
            flag: true,
        }
        if (queues.selectQueues) {
            API.eStartOrEndGame(params).then(res => {
            }).catch(e => {
                message.error(e || '服务器出现错误')
            })
            let data = this.createPlayingData();
            this.setState({ data })
        } else {
            message.error('请选择玩家')
        }
    }

    onEndPress = () => {
        //结束游戏
        const JurisdictionType = this.props.checkJurisdiction(); //检测是否有操作权限
        if (JurisdictionType < 0) {
            message.warning('对不起，您没有该区操作权限')
            return false;
        }
        const self = this;
        const { areaStatus } = self.props;
        let queues = self.getSelectQueues();
        const params = {
            queueGameIds: queues.selectQueues,
            orderTicketItemIds: queues.selectOrderTicketItemIds,
            flag: false,
        }
        API.eStartOrEndGame(params).then(res => {

        }).catch(e => {
            message.error(e || '服务器出现错误')
        })
        let data = this.createPlayingData();
        this.setState({ data })
    }

    //等待叫号
    waitForCallPlayer = () => {
        const JurisdictionType = this.props.checkJurisdiction(); //检测是否有操作权限
        if (JurisdictionType < 0) {
            message.warning('对不起，您没有该区操作权限')
            return false;
        }
        const hide = message.loading('请稍后...', 0);
        const { areaId, gameId, gameName, areaName } = this.props;
        const storeId = Common.getStoreInfo().storeId
        const dKey = `${areaId}-${gameId}`;
        let selectQueues = [];
        let queues = this.state.data[dKey];
        if (queues && Object.keys(queues).length > 0) {
            let qKeys = Object.keys(queues);
            qKeys.forEach(key => {
                if (queues[key].selected) {
                    selectQueues.push({
                        storeId,
                        gameName,
                        areaName,
                        gameId,
                        customerNum: queues[key].customerNum,
                        areaId: queues[key].areaId
                    })
                }
            });
        }
        if (selectQueues && selectQueues.length > 0) {
            API.ewaitCallNumber(selectQueues).then(res => {
                hide();
                message.success('等待叫号成功')
            }).catch(e => {
                hide();
                message.error('等待叫号失败,' + e);
            })
            let data = this.createPlayingData();
            this.setState({ data })
        } else {
            hide();
            message.error('未选取用户');
        }
    }

    //叫号
    onCallPlayer = () => {
        const JurisdictionType = this.props.checkJurisdiction(); //检测是否有操作权限
        if (JurisdictionType < 0) {
            message.warning('对不起，您没有该区操作权限')
            return false;
        }
        const hide = message.loading('请稍后...', 0);
        const { areaId, gameId, gameName, areaName } = this.props;
        const storeId = Common.getStoreInfo().storeId
        const dKey = `${areaId}-${gameId}`;
        let selectQueues = [];
        let queues = this.state.data[dKey];
        if (queues && Object.keys(queues).length > 0) {
            let qKeys = Object.keys(queues);
            qKeys.forEach(key => {
                if (queues[key].selected) {
                    selectQueues.push({
                        storeId,
                        gameName,
                        areaName,
                        gameId,
                        customerNum: queues[key].customerNum,
                        areaId: queues[key].areaId
                    })
                }
            });
        }
        if (selectQueues && selectQueues.length > 0) {
            API.eCallnumber(selectQueues).then(res => {
                hide();
                message.success('叫号成功')
            }).catch(e => {
                hide();
                message.error('叫号失败,' + e);
            })
            let data = this.createPlayingData();
            this.setState({ data })
        } else {
            hide();
            message.error('未选取用户');
        }
    }

    changeEmpty = () => {
        let data = this.createPlayingData();
        this.setState({ data })
    }

    render() {
        const self = this;
        const offSH = document.querySelector('body').clientHeight - 320;
        const { queueList, gameName, over, total, gameAreasSize, gameAreas, areaId, gameId, areaStatus, checkJurisdiction } = this.props;
        const { data } = this.state;
        return (
            <div style={{ marginRight: 30, borderRadius: 5, backgroundColor: '#1A1736', height: offSH }}>
                <GameListHeader onCallPlayer={this.onCallPlayer} waitForCallPlayer={this.waitForCallPlayer} areaStatus={areaStatus} gameName={gameName} gameQueue={`${over}/${total}`} onBeginPress={this.onBeginPress} onEndPress={this.onEndPress} gameId={gameId} areaId={areaId} getSelectQueues={this.getSelectQueues} checkJurisdiction={checkJurisdiction} changeEmpty={this.changeEmpty} />
                <Row style={{ fontSize: 10, backgroundColor: '#1A1736', color: '#b7b3c9', margin: '10px 10px 0 10px', paddingBottom: 10, borderBottom: '1px solid #322F52' }}>
                    <Col span={5} style={{ textAlign: 'right', paddingRight: 5 }}>序列号</Col>
                    <Col span={7} style={{ textAlign: 'center', paddingRight: 10 }}>顾客编号</Col>
                    <Col span={8} style={{ textAlign: 'center' }}>排队状态</Col>
                    <Col span={4} style={{ textAlign: 'center' }}>操作</Col>
                </Row>
                <DragDropContext onDragEnd={this.onDragEnd}>
                    <Droppable droppableId={`droppable-${areaId}-${gameId}`}>
                        {(provided, snapshot) => (
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                style={{ width: '340px', padding: '0 10px', backgroundColor: '#1A1736', height: offSH - 150, overflowY: 'auto', }}
                                key={`div_container_${areaId}-${gameId}`}
                                className="itemQueue"
                            >
                                {
                                    queueList.map((item, index) => (
                                        <Draggable key={`${areaId}-${gameId}-${item.queueGameId}`} draggableId={`${areaId}-${gameId}-${item.queueGameId}`} index={index}>
                                            {(provided, snapshot) => {
                                                let isSelected = false;
                                                if (data && data[`${areaId}-${gameId}`] && data[`${areaId}-${gameId}`][item.queueGameId]) {
                                                    isSelected = data[`${areaId}-${gameId}`][item.queueGameId].selected;
                                                }
                                                return (
                                                    <div
                                                        key={`div_${areaId}-${gameId}-${item.queueGameId}`}
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                    >
                                                        <BraceletItem
                                                            onItemChange={(selected) => {
                                                                const JurisdictionType = this.props.checkJurisdiction(); //检测是否有操作权限
                                                                if (JurisdictionType < 0) {
                                                                    message.warning('对不起，您没有该区操作权限')
                                                                    return false;
                                                                }
                                                                let arrs = { ...self.state.data };
                                                                const dKey = `${areaId}-${gameId}`
                                                                if (arrs[dKey]) {
                                                                    //存在 选择的
                                                                    if (arrs[dKey][item.queueGameId]) {
                                                                        arrs[dKey][item.queueGameId].selected = selected;
                                                                    } else {
                                                                        arrs[dKey][item.queueGameId] = {
                                                                            ...item,
                                                                            selected
                                                                        }
                                                                    }
                                                                } else {
                                                                    arrs[dKey] = {};
                                                                    arrs[dKey][item.queueGameId] = {
                                                                        ...item,
                                                                        selected
                                                                    }
                                                                }
                                                                self.setState({
                                                                    data: arrs
                                                                })
                                                            }}
                                                            isExchange={gameAreasSize > 1}
                                                            areas={gameAreas}
                                                            index={index + 1}
                                                            {...item}
                                                            isSelected={isSelected}
                                                            checkJurisdiction={checkJurisdiction}
                                                        />
                                                    </div>
                                                );
                                            }}
                                        </Draggable>
                                    ))
                                }
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </div>
        );
    }

    createPlayingData() {
        const { queues, areaId, gameId } = this.props;
        let arrs = {};
        const dKey = `${areaId}-${gameId}`;
        arrs[dKey] = {};
        queues.map(item => {
            if (item.queueStatus == 1) {
                arrs[dKey][item.queueId] = {
                    ...item,
                    selected: true
                }
            }
        });
        return arrs;
    }

}


class GameListHeader extends React.Component {
    static defaultProps = {
        gameName: '极速特工',
        gameQueue: '5/20'
    }
    constructor(props) {
        super(props);
        this.state = {
            areaGames: [],
            visible: false,
            curIndex: -1,
            loopType: true
        }
    }
    // getSelectQueues={this.getSelectQueues}
    render() {
        const { gameName, gameQueue, areaStatus, areaId, gameId,getSelectQueues,changeEmpty } = this.props;
        const { visible } = this.state
        const JurisdictionType = this.props.checkJurisdiction();

        return (
            <div style={{ padding: '15px 10px', color: 'white', backgroundColor: '#322F52', display: 'flex', flexDirection: 'column', alignItems: 'center', borderRadius: '5px 5px 0 0' }}>
                <div style={{
                    flex: 1, alignItems: 'center', width: '100%', display: 'flex', justifyContent: 'space-between', flexDirection: 'row'
                }}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <img src={require('../../../images/game_icon.png')} style={{ width: 18, height: 19 }} />
                        <span style={{ fontSize: 14, color: 'white', marginLeft: 5 }}>{gameName}</span>
                    </div>
                    <div style={{ position: 'relative' }}>
                        <Button style={{ width: 32, height: 32, border: 'none', borderRadius: 16, background: `url(${Background_icon})`, backgroundSize: '100%', marginRight: 5 }} onClick={this.props.onCallPlayer}></Button>
                        <ChangeCanArea JurisdictionType={JurisdictionType} areaId={areaId} gameId={gameId} getSelectQueues={getSelectQueues} changeEmpty={changeEmpty}/>
                    </div>
                </div>
                <div style={{ flex: 1, alignItems: 'center', width: '100%', marginTop: 10, display: 'flex', justifyContent: 'space-between', flexDirection: 'row', color: 'rgb(142,138,173)' }}>
                    <div>
                        <span style={{ fontSize: 14 }}>已体验/总排队</span>
                        <span style={{ fontSize: 14, marginLeft: 20 }}>{gameQueue}</span>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <span onClick={this.props.waitForCallPlayer} style={{ cursor: 'pointer', borderRadius: 5, padding: '3px 10px', fontSize: 10, color: 'white', backgroundColor: '#1A1736', }}>等待叫号</span>
                        <span onClick={this.props.onBeginPress} style={{ cursor: 'pointer', borderRadius: 5, padding: '3px 10px', fontSize: 10, color: 'white', backgroundColor: '#1A1736', marginLeft: 10 }}>开始</span>
                        <span onClick={this.props.onEndPress} style={{ cursor: 'pointer', borderRadius: 5, padding: '3px 10px', fontSize: 10, color: 'white', marginLeft: 10, backgroundColor: '#1A1736' }}>结束</span>
                    </div>
                </div>
            </div>
        );
    }

}
class ChangeCanArea extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            areaGames: [],
            visible: false,
            curIndex: -1,
            loopType: true
        }
    }

    componentDidMount() {
        setTimeout(() => {
            this.getCanChangeArea()
        }, 800)

    }

    handleVisibleChange = visible => {
        this.setState({ visible });
    };

    changeArea = () => {
        const { curIndex, areaGames } = this.state
        if (curIndex == -1) {
            message.error('请选择要更换的区域')
            return false
        }
        const selectedAreaId = areaGames[curIndex].areaId
        const selectedQuere = this.props.getSelectQueues()
        const queueGameIds = selectedQuere.selectQueues
        if (queueGameIds == '') {
            message.error('请选择要更换用户')
            return false
        }
        let params = {
            areaId: selectedAreaId,
            queueGameIds: queueGameIds,
        }
        API.eChangeArea(params).then((res) => {
            message.success('换区成功');
            
        }).catch((e) => {
            message.error(`换区失败！${e}`);
        })
        this.props.changeEmpty()
        this.hide();
        this.setState({
            curIndex: -1,
        })
    }

    hide = () => {
        this.setState({
            visible: false,
            curIndex: -1,
        });
    };

    getCanChangeArea = () => {
        const { loopType } = this.state
        if (loopType) {
            const { gameId, areaId } = this.props
            const storeId = Common.getStoreInfo().storeId
            API.getIdenticalGame(storeId, gameId).then((res) => {
                let _res = res.filter(item => item.areaId != areaId)

                this.setState({
                    areaGames: _res
                })
            }).catch((e) => {
                message.error(`查询失败:${e}`);
            })
            this.setState({
                loopType: false,
            })
        }
    }

    changeAreaBox = () => {
        const { areaGames, curIndex } = this.state;
        const checkBoxStyle = { fontSize: 18, fontWeight: 'bold', };
        return <div style={{ width: 300, backgroundColor: '#1A1736', borderRadius: 8, padding: 10,}} >
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <div style={{ color: '#6E738E', fontSize: 14, marginBottom: 10 }}>调换区域</div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <Button style={{ width: 40, height: 18, border: 'none', borderRadius: 5, backgroundColor: '#322F52', marginRight: 5, fontSize: 10, color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { this.hide() }}>取消</Button>
                    <Button style={{ width: 40, height: 18, border: 'none', borderRadius: 5, backgroundColor: '#22E6A3', marginRight: 5, fontSize: 10, color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                        onClick={() => { this.changeArea() }}>确定</Button>
                </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', }}>
                {
                    areaGames.length ? areaGames && areaGames.map((item, index) => {
                        return (
                            <div style={{ display: 'flex', flexDirection: 'row', padding: '5px 10px', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }} onClick={() => { this.setState({ curIndex: index }) }} key={`abs-${index}`}>
                                <div style={{ backgroundColor: curIndex == index ? '#FFFFFF' : '', lineHeight: 0, width: 15, height: 15, padding: 0, margin: 0, position: 'relative' }}>
                                    {
                                        curIndex == index ? <Icon type="check-square" theme="filled" style={{ ...checkBoxStyle, color: '#22E6A3', position: 'absolute', top: -1, left: -1 }} /> : <Icon type="border" style={{ ...checkBoxStyle, color: 'white', position: 'absolute', top: -1, left: -1 }} />
                                    }
                                </div>
                                <div style={{ color: 'white', fontSize: 14, marginLeft: 5 }}>{item.areaName}</div>
                            </div>
                        )
                    }) : <span style={{ color: '#6E738E', fontSize: 14 }}>暂无可调换区域！</span>
                }
            </div>
        </div>
    }

    render() {
        const { visible } = this.state
        return (
            <Popover placement="bottomLeft" trigger="click" visible={visible} content={this.props.JurisdictionType < 0 ? null : this.changeAreaBox()} onVisibleChange={this.handleVisibleChange}>
                <Button style={{ width: 32, height: 32, border: 'none', borderRadius: 16, background: `url(${Change_icon})`, backgroundSize: '100%' }} ></Button>
            </Popover>
        )
    }

}

class BraceletItem extends React.Component {
    static defaultProps = {
        index: 1,
        queueNum: 12,
        teamId: 2,
        isExchange: false
    }
    constructor(props) {
        super(props);
        let curDate = moment();
        const timestamp = new Date().getTime();
        let createDate = moment(((timestamp - props.waitingTime) + '') * 1);
        this.onMouseOver = this.onMouseOver.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.onClick = this.onClick.bind(this);
        this.CancelBox = this.CancelBox.bind(this)
        this.state = {
            // isSelected: false,
            backgroundColor: '#1A1736',
            waitDuration: curDate.diff(createDate, 'minute') + '',
            visible: false
        }
    }

    onClick() {
        let { isSelected } = this.props;
        // this.setState({ isSelected: !isSelected });
        this.props.onItemChange && this.props.onItemChange(!isSelected);
    }

    onMouseOver() {
        this.setState({ backgroundColor: '#322F52', })
    }

    onMouseLeave() {
        let { isSelected } = this.props;
        if (!isSelected) {
            this.setState({ backgroundColor: '#1A1736' })
        }
    }

    CancelBox(queueGameId) {
        return (
            <div style={{ backgroundColor: '#322F52', borderRadius: 8, display: 'flex', flexDirection: 'row', width: 100, height: 36, justifyContent: 'center', alignItems: 'center', boxShadow: '2px 2px 2px 2px rgba(21,19,46,0.49)' }}>
                <div style={{ fontSize: 14, color: '#fff', cursor: 'pointer' }} onClick={() => { this.cancelLineUp(queueGameId) }}>取消排队</div>
                <img src={require('../../../images/cancel_queue_icon.png')} style={{ width: 14, height: 14, marginLeft: 6, cursor: 'pointer', }} onClick={() => { this.hide() }}></img>
            </div>
        )
    }

    hide = () => {
        this.setState({
            visible: false,
        });
    };

    handleVisibleChange = visible => {
        this.setState({ visible });
    };
    /**
     * 取消排队
     */
    cancelLineUp = (queueGameId) => {
        let params = {
            queueGameId,
        }
        API.eCancelQueue(params).then((res) => {
            message.success('取消成功！')
            this.setState({
                isShowCancelBox: false,
            })
        }).catch((res) => {
            message.error(res)
        })
    }

    render() {
        const { index, queueNum, teamId, priority, customerStatus, isExchange, areas, queueId, areaId, queueStatus, guestStatus, status, queueGameId, isSelected, onItemChange, customerNum } = this.props;
        const JurisdictionType = this.props.checkJurisdiction(); //检测是否有操作权限
        const { backgroundColor, waitDuration, visible } = this.state;
        const priorityColor = priority == 1 ? 'rgb(0,0,0,0)' : priority == 2 ? 'rgba(255,255,46,1)' : priority == 3 ? 'rgba(255,120,0,1)' : 'rgba(228,39,39,1)';
        const bgColor = backgroundColor;
        return (
            <Row onMouseOver={this.onMouseOver} onMouseLeave={this.onMouseLeave} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 10, backgroundColor: bgColor, color: customerStatus == 4 ? '#6E738E' : 'white', borderBottom: '1px solid #322F52', height: 44 }}>
                <Col span={4} style={{ position: 'relative', height: '100%', display: 'flex', justifyContent: 'cneter', alignItems: 'center' }}>
                    {
                        <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center', paddingRight: 5, paddingLeft: 4 }} onClick={this.onClick}>
                            {isSelected ? <img src={require('../../../images/checkSquare_icon.png')} style={{ width: 14, height: 14 }} /> : <img src={require('../../../images/border_icon.png')} style={{ width: 14, height: 14 }} />}
                            <span style={{ fontSize: 14, color: customerStatus == 4 ? '#6E738E' : status == 1 ? '#22EAA4' : '#fff' }}>{index}</span>
                        </div>
                    }
                    <div style={{ position: 'absolute', top: 0, left: 0, width: 4, height: '100%', backgroundColor: priorityColor, borderRadius: '5px 0 0 5px' }}></div>
                </Col>
                <Col span={8} style={{ textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', }}>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                            <span style={{ fontSize: 14, color: customerStatus == 4 ? '#6E738E' : status == 1 ? '#22EAA4' : '#fff' }}>{customerNum}</span>
                        </div>
                        {
                            teamId ? <span style={{ color: '#6E738E', fontSize: 10 }}>TEAM {teamId}</span> : null
                        }
                    </div>
                </Col>
                <Col span={8} style={{ textAlign: 'center' }}>
                    {
                        customerStatus == 4 ? <span style={{ fontSize: 14, color: '#6E738E' }}>离店</span> : <span style={{ fontSize: 14, color: status == 1 ? '#22EAA4' : '#fff' }}> {(status == 1 ? "游戏中" : `已等待${waitDuration}分钟`)}</span>
                    }
                </Col>
                <Col span={4} style={{ textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
                    <Popover placement="bottomLeft" trigger="click" visible={visible} content={JurisdictionType < 0 ? null : this.CancelBox(queueGameId)} onVisibleChange={this.handleVisibleChange}>
                        <div style={{ cursor: 'pointer', height: '20px', display: 'flex', justifyContent: 'center', alignItems: "center" }} >
                            <img src={require('../../../images/cancelQueueUp.png')} style={{ width: 15, height: 3, }}></img>
                        </div>
                    </Popover>
                </Col>
            </Row>
        );
    }

}

//区域维护 叫号开启/叫号关闭
class Maintain extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    showModal = () => {
        this.setState({
            visible: true,
        });
    };

    handleOk = e => {
        const { storeAreaGameInfo, activeIndex } = this.props
        const MaintainType = storeAreaGameInfo[activeIndex].areaStatus
        let params = {
            flag: !MaintainType,
            areaId: storeAreaGameInfo[activeIndex].areaId
        }
        API.emaintainArea(params).then((res) => {
            message.success('操作成功')
        }).catch((e) => {
            message.error('区域维护操作失败')
        })
        this.setState({
            visible: false,
        });
    };

    handleCancel = e => {
        this.setState({
            visible: false,
        });
    };

    render() {
        const { storeAreaGameInfo, activeIndex } = this.props
        const MaintainType = storeAreaGameInfo[activeIndex] && storeAreaGameInfo[activeIndex].areaStatus
        return (
            <div>
                <Modal
                    title="提示"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    bodyStyle={{ backgroundColor: 'white' }}
                    footer={false}
                    wrapClassName={'queuesModal'}
                >
                    <div style={{ padding: 10, display: 'flex', flexDirection: 'column' }}>
                        <div style={{ color: '#656565', fontSize: 12 }}>{MaintainType ? '是否确认恢复排队叫号？' : '维护中的区域将无法继续排队叫号，是否确定将区域状态改为“维护中”？'}</div>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: 67 }}>
                            <Button style={{ fontSize: 12, color: '#BCBCBC', marginRight: 8, }} onClick={() => { this.handleCancel() }}>取消</Button>
                            <Button style={{ fontSize: 12, color: '#fff', marginLeft: 8, backgroundColor: '#22E6A3', border: 'none' }} onClick={() => {
                                this.handleOk()
                            }}>确定</Button>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }

}

//区域排队 排队开启/排队关闭
class Queueup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    showModal = () => {
        this.setState({
            visible: true,
        });
    };

    handleOk = () => {
        const { storeAreaGameInfo, activeIndex } = this.props
        const MaintainType = storeAreaGameInfo[activeIndex].areaQueueStatus
        let params = {
            flag: !MaintainType,
            areaId: storeAreaGameInfo[activeIndex].areaId
        }
        API.eQueueUpArea(params).then((res) => {
            message.success('操作成功')
        }).catch((e) => {
            message.error('区域排队操作失败')
        })
        this.setState({
            visible: false,
        });
    };

    handleCancel = e => {
        this.setState({
            visible: false,
        });
    };

    render() {
        const { storeAreaGameInfo, activeIndex } = this.props
        const MaintainType = storeAreaGameInfo[activeIndex] && storeAreaGameInfo[activeIndex].areaQueueStatus
        return (
            <div>
                <Modal
                    title="提示"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    bodyStyle={{ backgroundColor: 'white' }}
                    footer={false}
                    wrapClassName={'queuesModal'}
                >
                    <div style={{ padding: 10, display: 'flex', flexDirection: 'column' }}>
                        <div style={{ color: '#656565', fontSize: 12 }}>{MaintainType ? '操作后当前区域将恢复排队叫号，是否确认操作？' : '操作后当前区域将无法继续加入排队，是否确认操作？'}</div>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: 67 }}>
                            <Button style={{ fontSize: 12, color: '#BCBCBC', marginRight: 8, }} onClick={() => { this.handleCancel() }}>取消</Button>
                            <Button style={{ fontSize: 12, color: '#fff', marginLeft: 8, backgroundColor: '#22E6A3', border: 'none' }} onClick={() => { this.handleOk() }}>确定</Button>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }

}